/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AI Interview API
 * OpenAPI spec version: 1.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorResponse,
  SetupAuthResponse,
  SetupLoginRequest,
  SetupRegisterRequest,
  Viewer
} from '../../types';

import { customFetch } from '../../../lib/fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type registerUserResponse200 = {
  data: SetupAuthResponse
  status: 200
}

export type registerUserResponse400 = {
  data: ErrorResponse
  status: 400
}
    
export type registerUserResponseSuccess = (registerUserResponse200) & {
  headers: Headers;
};
export type registerUserResponseError = (registerUserResponse400) & {
  headers: Headers;
};

export type registerUserResponse = (registerUserResponseSuccess | registerUserResponseError)

export const getRegisterUserUrl = () => {


  

  return `/api/v1/setup/register`
}

export const registerUser = async (setupRegisterRequest: SetupRegisterRequest, options?: RequestInit): Promise<registerUserResponse> => {
  
  return customFetch<registerUserResponse>(getRegisterUserUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setupRegisterRequest,)
  }
);}




export const getRegisterUserMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: SetupRegisterRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: SetupRegisterRequest}, TContext> => {

const mutationKey = ['registerUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerUser>>, {data: SetupRegisterRequest}> = (props) => {
          const {data} = props ?? {};

          return  registerUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterUserMutationResult = NonNullable<Awaited<ReturnType<typeof registerUser>>>
    export type RegisterUserMutationBody = SetupRegisterRequest
    export type RegisterUserMutationError = ErrorResponse

    export const useRegisterUser = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: SetupRegisterRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerUser>>,
        TError,
        {data: SetupRegisterRequest},
        TContext
      > => {

      const mutationOptions = getRegisterUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type loginUserResponse200 = {
  data: SetupAuthResponse
  status: 200
}

export type loginUserResponse401 = {
  data: ErrorResponse
  status: 401
}
    
export type loginUserResponseSuccess = (loginUserResponse200) & {
  headers: Headers;
};
export type loginUserResponseError = (loginUserResponse401) & {
  headers: Headers;
};

export type loginUserResponse = (loginUserResponseSuccess | loginUserResponseError)

export const getLoginUserUrl = () => {


  

  return `/api/v1/setup/login`
}

export const loginUser = async (setupLoginRequest: SetupLoginRequest, options?: RequestInit): Promise<loginUserResponse> => {
  
  return customFetch<loginUserResponse>(getLoginUserUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setupLoginRequest,)
  }
);}




export const getLoginUserMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginUser>>, TError,{data: SetupLoginRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof loginUser>>, TError,{data: SetupLoginRequest}, TContext> => {

const mutationKey = ['loginUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginUser>>, {data: SetupLoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  loginUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LoginUserMutationResult = NonNullable<Awaited<ReturnType<typeof loginUser>>>
    export type LoginUserMutationBody = SetupLoginRequest
    export type LoginUserMutationError = ErrorResponse

    export const useLoginUser = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginUser>>, TError,{data: SetupLoginRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loginUser>>,
        TError,
        {data: SetupLoginRequest},
        TContext
      > => {

      const mutationOptions = getLoginUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type getViewerResponse200 = {
  data: Viewer
  status: 200
}

export type getViewerResponse401 = {
  data: ErrorResponse
  status: 401
}
    
export type getViewerResponseSuccess = (getViewerResponse200) & {
  headers: Headers;
};
export type getViewerResponseError = (getViewerResponse401) & {
  headers: Headers;
};

export type getViewerResponse = (getViewerResponseSuccess | getViewerResponseError)

export const getGetViewerUrl = () => {


  

  return `/api/v1/me`
}

export const getViewer = async ( options?: RequestInit): Promise<getViewerResponse> => {
  
  return customFetch<getViewerResponse>(getGetViewerUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetViewerInfiniteQueryKey = () => {
    return [
    'infinite', `/api/v1/me`
    ] as const;
    }

export const getGetViewerQueryKey = () => {
    return [
    `/api/v1/me`
    ] as const;
    }

    
export const getGetViewerInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getViewer>>>, TError = ErrorResponse>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetViewerInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getViewer>>> = ({ signal }) => getViewer({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetViewerInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getViewer>>>
export type GetViewerInfiniteQueryError = ErrorResponse


export function useGetViewerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getViewer>>>, TError = ErrorResponse>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getViewer>>,
          TError,
          Awaited<ReturnType<typeof getViewer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetViewerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getViewer>>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getViewer>>,
          TError,
          Awaited<ReturnType<typeof getViewer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetViewerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getViewer>>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetViewerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getViewer>>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetViewerInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetViewerInfiniteQuery = async <TData = Awaited<ReturnType<typeof getViewer>>, TError = ErrorResponse>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetViewerInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetViewerQueryOptions = <TData = Awaited<ReturnType<typeof getViewer>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetViewerQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getViewer>>> = ({ signal }) => getViewer({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetViewerQueryResult = NonNullable<Awaited<ReturnType<typeof getViewer>>>
export type GetViewerQueryError = ErrorResponse


export function useGetViewer<TData = Awaited<ReturnType<typeof getViewer>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getViewer>>,
          TError,
          Awaited<ReturnType<typeof getViewer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetViewer<TData = Awaited<ReturnType<typeof getViewer>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getViewer>>,
          TError,
          Awaited<ReturnType<typeof getViewer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetViewer<TData = Awaited<ReturnType<typeof getViewer>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetViewer<TData = Awaited<ReturnType<typeof getViewer>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetViewerQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetViewerQuery = async <TData = Awaited<ReturnType<typeof getViewer>>, TError = ErrorResponse>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getViewer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetViewerQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



